import type { Component } from 'vue';
import { SingletonComponentInstance } from './SingletonComponentInstance';

export const useSingletonComponent = <T extends Component>(
    component: T
): SingletonComponentInstance<T> => {
    return SingletonComponentInstance.getInstance(component);
};